<template>
	<div class="tb-select-list">
		<!-- Label -->
		<label v-if="labelText">
			{{ labelText }}
		</label>
		<!-- Search -->
		<md-field v-if="searchAllow">
			<label>{{ $t("common.search") }}</label>
			<md-input @input="search" :value="searchValue" :disabled="disabled"/>
		</md-field>
		<!-- List content -->
		<md-list :style="listStyle">
			<md-list-item v-for="item in searchResults" :key="getOptionKey(item)">
				<md-checkbox v-model="value" :value="getOptionValue(item)" @change="onSelect" :disabled="disabled"/>
				<span class="md-list-item-text">{{ getOptionDisplayValue(item) }}</span>
			</md-list-item>
			<md-list-item v-if="searchResults && searchResults.length === 0" disabled>
				<span class="md-list-item-text">{{ emptyText }}</span>
			</md-list-item>
		</md-list>
	</div>
</template>

<script>
import SelectBaseComponent from "@/components/templates/common/SelectBaseComponent";

export default {
	extends: SelectBaseComponent,
	props: {
		value: { type: Array, default: [] }, // Selected values list
		labelText: { type: String, default: null }, // Optional label name for this list
		listMinHeight: { type: Number, default: 0 }, // Minimum height for the list container. No minimum by default
		listMaxHeight: { type: Number, default: 0 }, // Maximum height for the list container. Scrolling is enabled if the content exceeds the height. No maximum by default
	},
	computed: {
		listStyle() {
			return {
				...(this.listMinHeight > 0 ? { 'min-height': this.listMinHeight + 'px' } : {}),
				...(this.listMaxHeight > 0 ? { 'max-height': this.listMaxHeight + 'px' } : {}),
			}
		}
	},
	methods: {
		onSelect() {
			this.$emit("input", this.value)
		}
	},
};
</script>

<style lang="scss">
@import "@/assets/scss/base_variables.scss";

.tb-select-list {
	display: flex;
	flex-direction: column;

	.md-list {
		padding-top: 0;
		overflow: auto;

		.md-list-item-content {
			padding: 5px 5px 5px 0;
			min-height: 0;
			font-size: $root-font-size;
			cursor: pointer;

			.md-checkbox {
				margin-right: 1rem;
			}

			span {
				position: unset;
				margin-right: 5px;
				white-space: break-spaces;
			}
		}
	}
}
</style>